import { Link, useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
    const navigate = useNavigate();
    const handleViewProducts = () => {
        navigate('/products');
    };


    const products = [
        { name: 'Rice Products', image: '/images/products/rice.webp', link: '/rice' },
        { name: 'Oil Products', image: '/images/products/oil.webp', link: '/oil' },
        { name: 'Masala Powder', image: '/images/products/masala.webp', link: '/masala' },
        { name: 'Lentils & Pulses', image: '/images/products/pulse.webp', link: '/lentils' },
        { name: 'Sugars', image: '/images/products/sugar.webp', link: '/sugars' },
        { name: 'Salts', image: '/images/products/salts.webp', link: '/salts' },
        { name: 'Dried Rice Fryums', image: '/images/products/dryrice.webp', link: '/dryrice' },
        { name: 'Flours', image: '/images/products/flours.webp', link: '/flours' },
        { name: 'Pickles', image: '/images/products/pickles.webp', link: '/pickles' },
        { name: 'Ready Mix', image: '/images/products/sauces.webp', link: '/sauces' },
        { name: 'Millets', image: '/images/products/millets.webp', link: '/millets' },
        { name: 'Sun Dried Vegetables', image: '/images/products/sundried.webp', link: '/sundry' },
        { name: 'Cereals', image: '/images/products/cereals.webp', link: '/cereals' },
        { name: 'Claypots', image: '/images/products/pots.webp', link: '/pots' }
    ];



    return (
        <section className="hero">
            <div className="hero-container" style={{ backgroundImage: `url(/images/hero.png)` }}>
                <div className="hero-content">
                    <h2>Global Goods, Tailored Solutions<br></br>Redefining Export for the Modern World.</h2> 
                    <button className="shop-btn" onClick={handleViewProducts}>Shop Now</button>
                </div>
            </div>

            {/* <div className='hero-section'>
            <img src='./images/hero.png' className='hero-img'></img>
            <div className="hero-text">
                <h1>Discover the Essence of<br></br> Fresh Spices</h1>
                <p>
                    Spices are premium because they are sourced directly from small farmers in Munnar,<br></br>
                    Kerala, ensuring the highest quality and authenticity.
                </p>
                <button className="shop-now" onClick={handleViewProducts}>Shop Now</button>
            </div> */}
            {/* <div className="hero-images">
                <img src="/images/spices-left.png" alt="Spices Left" className="left" />
                <img src="/images/spices-center.png" alt="Spices Center" className="center" />
                <img src="/images/spices-right.png" alt="Spices Right" className="right" />
            </div> */}
            {/* </div> */}
            <div className='border'>
                <img src="/images/border.png" className='border-img' alt="decorative border" />
            </div>

            <section className='cate'>
                <div className='cate-text'>
                    <h1>Our Cate</h1>
                    <p>Checkout our extensive range of Agro food products right from Turmeric,<br></br> Chilli to all type of Whole Spices, Blended Spices & more.</p>
                </div>
                <div className="product-grid">
                    {products.map((product, index) => (
                        <div className="product-card" key={index}>
                            {product.link ? (
                                <Link to={product.link}>
                                    <img src={product.image} alt={product.name} />
                                </Link>
                            ) : (
                                <img src={product.image} alt={product.name} />
                            )}
                            <div className="product-name">{product.name}</div>
                        </div>
                    ))}
                </div>
                <div className='view-prod-btn'>
                    <button className='view-products' onClick={handleViewProducts}>View All Products</button>
                </div>

            </section>
            <div className='border'>
                <img src="/images/border.png" className='border-img' alt="decorative border" />
            </div>
            <section className='about' id='about'>
                <h1>About Us</h1>
                <p>Since our inception in 2016, we've evolved from a dedicated merchant exporter of fresh perishables by air to a comprehensive global trade solution. We quickly expanded into containerized sea cargo, scaling our reach and diversifying our offerings. Remember Kalimark Bovonto and Paneer Soda hitting shelves in the UAE, Brunei, Australia, and Seychelles? That was us, proudly introducing these beloved beverages to new markets as their official exporters!</p>
                <p>We didn't stop there. Our portfolio rapidly grew to include a wide array of grocery and branded items, alongside our continued expertise in exporting perishable delights like traditional sweets and snacks.</p>
                <img src='/images/aboutus.webp' className='about-img'></img>
                <p>Innovation is at our core. We've established a dedicated packing unit for private labeling, empowering businesses to create their own unique brand presence. Further solidifying our commitment to quality, we launched a state-of-the-art cold-pressed oil production unit, serving both international export and local distribution needs.</p>

                <p>Today, we proudly operate under our proprietary brand, JEYAM, offering customized packaging solutions that truly stand out. And for those with a sweet tooth, we introduced KADMIT, our trademarked confectionery brand, renowned for its authentic and delicious Kadalamittai (chikki). Both JEYAM and KADMIT embody our dedication to quality and authenticity.</p>
                <div className='container'>
                    <div className='founder-section'>
                        <div className='founder-img-box'>
                            <img src="/images/home.jpg" className='founder-img' alt="Founder" />
                        </div>
                        <div className='founder-text-box'>
                            <h4>A Note from the Founder</h4>
                            <p>Welcome to JP Exports! We are a leading Merchant exporter and Manufacturer specializing in high-quality oil and salt products. What sets us apart is our unwavering commitment to our customers, offering customized packing and white labelling services to meet your unique needs.</p>
                            <p>Partner with JP Exports and discover a truly customer-centric experience. We're here to help your business thrive!</p>
                            <button onClick={() => navigate('/founder')}>Read More</button>
                        </div>
                    </div>
                </div>

            </section>
            <section className="global-reach">
                <div className="reach-top">
                    <div className="map-container">
                        <img src='/images/map.jpg' alt="Global Map"></img>
                    </div>
                   
                </div>

                <div className="reach-stats">
                    <div className="stat-item">
                        <h3>300+</h3>
                        <p>Varieties of Spices,<br />Herbs & seasoning</p>
                    </div>
                    <div className="stat-item">
                        <h3>10+</h3>
                        <p>Countries<br />Importing & Exporting</p>
                    </div>

                    <div className="stat-item">
                        <h3>15+</h3>
                        <p>International & Local<br />Brands Served</p>
                    </div>
                </div>
            </section>
            <div className='border'>
                <img src="/images/border.png" className='border-img' alt="decorative border" />
            </div>
            <div className='address'>
                <img src='/images/jpexports.png' className='jp'></img>
                <p>5/206, H3, Tiruchendur Road, Opp. Spic Nagar,<br></br>
                    Muthunagar Medical Complex, Muthiahpuram,<br></br>
                    Thoothukudi - 628005. Tamilnadu, India.<br></br>
                    Mobile: +91 9843156891 Email: jp.exports@yahoo.com<br></br>
                    GSTIN: 33ASGPV3220K3ZN<br></br>
                    IEC NO: 3513007965 PAN NO: ASGPV3220K</p><br></br>
                <img src='/images/jeyam-address.png' className='jp'></img>
                <h2>PACKING UNIT</h2>
                <p>4/130-106, JP Garden, Ponnagaram South, Athimarappatti,<br></br>
                    Thoothukudi - 628005. Tamilnadu, India.<br></br>
                    Mobile : +91 9843156891 Email : jeyamtradingagencies@gmail.com<br></br>
                    CIN : U51909TN2017OPC115071 GSTIN : 33AADCJ8935H1ZF</p><br></br>
            </div>

        </section>
    );
};

export default Hero;
